import { createRecord } from '@/entities/shared/record/create-record';
import { type KitDocument, kitDocumentSchema } from '../schemas/kit-document';

export async function createDocument(data: Partial<KitDocument>): Promise<string> {
  return createRecord('documents', kitDocumentSchema, data);
}
